module.exports = __webpack_public_path__ + "img/horizontal_3_7_7016.3755f3b8.png";